module.exports = __webpack_public_path__ + "static/media/load2.17b7a115.gif";